import { get_token } from "@/router";

const homeJourneyDonationStats = {
  fetch_donation_stats() {
    if (!this.active_features?.show_donations || !get_token()) return Promise.resolve();

    return this.request_home_stat({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/donation_management/get_campaigns/`,
      method: "GET",
      headers: this.get_auth_headers(),
    }).then((response) => this.apply_donation_stats(response));
  },

  apply_donation_stats(response) {
    const campaigns = response?.data || [];
    const dashboard = response?.dashboard || {};
    const active_campaigns = campaigns.filter(
      campaign => String(campaign?.status || "").toLowerCase() === "active"
    ).length;
    const completed_donations = campaigns.reduce((total, campaign) => {
      const donations = Array.isArray(campaign?.donations) ? campaign.donations : [];
      return total + donations.filter(
        donation => String(donation?.donation_status || "").toLowerCase() === "completed"
      ).length;
    }, 0);
    const completed_amount = this.get_dashboard_value(
      dashboard,
      ["total_completed_amount", "total_current_amount"],
      campaigns.reduce((total, campaign) => total + Number(campaign?.current_amount || 0), 0)
    );

    this.set_card_stats("donations", [
      { label: "raised", value: completed_amount, format: "currency" },
      { label: "active", value: this.get_dashboard_value(dashboard, "active_count", active_campaigns) },
      { label: "donations", value: this.get_dashboard_value(dashboard, "completed_donation_count", completed_donations) },
    ]);
  },
};

export default homeJourneyDonationStats;
